import env from '@/lib/env'

const allBlogLink = `${env.BLOG_BASE_PATH}`

export default {
  allBlogLink,
}
